import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
    CapacitateCreștereAddPayload, CapacitateCreștereEditPayload,
} from './capacitate-crestere.interface';

@Injectable({
    providedIn: 'root'
})
export class CapacitateCreștereService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil.list;

    public listDTUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil.listDT;

    private findURL =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil.find;

    private storeURL =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil.store;

    private updateUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil.update;

    private deleteUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.dgaspc.activitati.nomenclatoare.capacitateCrestereCopil
            .public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: CapacitateCreștereAddPayload) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: CapacitateCreștereEditPayload) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}